import { all, fork } from 'redux-saga/effects';
import {
  handleCreateComparativeStudies,
  handleDeleteComparativeStudies,
  handleFetchComparativeStudies,
  handleFetchComparativeStudy,
  handleUpdateComparativeStudies,
} from '../../store/comparativeStudies/saga';

import {
  handleCreateMarketStudy,
  handleDeleteMarketStudies,
  handleFetchMarketStudies,
  handleFetchMarketStudyResult,
  handleUpdateMarketStudy,
} from '../../store/marketStudies/saga';

import {
  handleCreateProcedureEvents,
  handleDeleteProcedureEvents,
  handleFetchDashboardProcedureEvents,
} from '../../features/procedureEvent/saga';
import {
  handleCreateAdStudies,
  handleDeleteAdStudies,
  handleFetchAdStudy,
  handleMoveAdStudies,
  handleUpdateMultipleAdStudyForm,
} from '../../store/adStudies/saga';
import { handleFetchAnnouncements } from '../../store/announcements/saga';

import { handleFetchComparativeStudyComparisons } from '../../store/comparativeStudyComparisons/saga';
import { handleFetchPropertyTypologies } from '../../store/propertyTypologies/saga';

export default function* rootSaga() {
  yield all([
    // market studies
    fork(handleFetchMarketStudies),
    fork(handleCreateMarketStudy),
    fork(handleUpdateMarketStudy),
    fork(handleDeleteMarketStudies),
    fork(handleFetchMarketStudyResult),
    // comparatives studies
    fork(handleFetchComparativeStudies),
    fork(handleCreateComparativeStudies),
    fork(handleUpdateComparativeStudies),
    fork(handleDeleteComparativeStudies),
    fork(handleFetchComparativeStudy),
    fork(handleFetchComparativeStudyComparisons),

    // property typologies
    fork(handleFetchPropertyTypologies),
    // ad Studies
    fork(handleMoveAdStudies),
    fork(handleFetchAdStudy),
    fork(handleDeleteAdStudies),
    fork(handleUpdateMultipleAdStudyForm),
    fork(handleCreateAdStudies),
    // procedure events
    fork(handleCreateProcedureEvents),
    fork(handleDeleteProcedureEvents),
    fork(handleFetchDashboardProcedureEvents),
    // announcements
    fork(handleFetchAnnouncements),
  ]);
}
